import { lazy } from "react";
import { Droplets } from "lucide-react";

import type { FeatureDescriptor } from "@/features/types";

export const nrwFeature: FeatureDescriptor = {
  id: "nrw",
  flag: "nrw",
  path: "/nrw",
  group: "analyse",
  navKey: "nav.nrw",
  icon: Droplets,
  element: lazy(() => import("./NrwPage")),
  // Every locality is exactly one DMA, so the overview and trend follow the scope's
  // locality (`core.nrw_basis`). Starts system-wide: the headline is the Dashboard's
  // NRW KPI, and inheriting a remembered locality would show the same metric with a
  // different value.
  scope: { locality: true, days: true, inheritLocality: false },
};
